<div class="body-container">
    <div class="page-main">
        <div class="page-container">

            <div class="form-wrapper">
                <div class="form-content">


                    <div class="form-section">
                        <div class="form-section-side">
                            <h1 class="label-title">Recent events</h1>
                        </div>
                        <div class="form-section-container">
                            <div class="form-section-head">
                                <div class="form-row">
                                    <p class="typo caption fw300 semi-condensed">GitLab events trigger webhooks. Use the
                                        request details of a webhook to help troubleshoot problems.</p>
                                </div>
                            </div>
                            <div class="form-section-body">
                                <div class="form-row">
                                    <div class="jsonlabel">
                                        Response Body
                                    </div>
                                </div>
                                <div class="form-row">
                                    <div class="response-cnt">
                                        <ng-container *ngIf="empty(log.responseBody)">
                                            Response body is empty
                                        </ng-container>
                                        <ng-container *ngIf="!empty(log.responseBody)">
                                            {{log.responseBody | json}}
                                        </ng-container>
                                    </div>
                                </div>
                                <div class="form-row">
                                    <div class="jsonlabel">
                                        Response Headers
                                    </div>
                                </div>
                                <div class="form-row">
                                    <div class="response-cnt">
                                        <ng-container *ngIf="empty(log.responseHeaders)">
                                            Response headers data is empty
                                        </ng-container>
                                        <ng-container *ngIf="!empty(log.responseHeaders)">
                                            {{log.responseHeaders | json}}
                                        </ng-container>
                                    </div>
                                </div>
                                <div class="form-row">

                                    <div class="jsonlabel">
                                        Request Body
                                    </div>
                                </div>
                                <div class="form-row">
                                    <div class="response-cnt">
                                            <ng-container *ngIf="empty(log.requestBody)">
                                                Request body is empty
                                            </ng-container>
                                            <ng-container  *ngIf="!empty(log.requestBody)">
                                                {{log.requestBody | json}}
                                             </ng-container>
                                        </div>
                                </div>
                                <div class="form-row">
                                    <div class="jsonlabel">
                                        Request Headers
                                    </div>
                                </div>
                                <div class="form-row">
                                    <div class="response-cnt">
                                        <ng-container *ngIf="empty(log.requestHeaders)">
                                            Request headers data is empty
                                        </ng-container>
                                        <ng-container *ngIf="!empty(log.requestHeaders)">
                                            {{log.requestHeaders | json}}
                                        </ng-container>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <nav class="post-form">

                <button mat-flat-button routerLink="../../" color="primary"
                    class="custom-mat-button-primary rounded typo uppercase size size1of1 ">Back</button>

            </nav>


        </div>
    </div>
</div>
